import { CodeNameEntity } from "../common/code-name-entity";

export class AssetEmployeeEdit {
    id: number;
    invNo: string;
    name: string;
    serialNumberFinal: string;
    info: string;
    info2019: string;
    brand: CodeNameEntity;
    dictionaryItem: CodeNameEntity;
    validated: boolean;
    dictionaryItemId: number;
    brandId: number;
}
